export const PLASMIC_TESTIMONIAL_QUERY_KEY = "plasmic-testimonial-data";

export const T002_TABLE_ID = "t002";

export const CMS_SECTION_FIELDS = {
  TESTIMONIAL: "testimonial",
} as const;

export const TESTIMONIAL_SLIDE_FIELDS = {
  BRAND_LOGO: "Brand Logo",
  AUTHOR_NAME: "Author Name",
  SLIDE_IMAGE: "Slide Image",
  AUTHOR_AVATAR: "Author Avatar",
  SLIDE_ALT_TEXT: "Slide Alt Text",
  AUTHOR_AVATAR_ALT: "Author Avatar Alt",
  AUTHOR_DESIGNATION: "Author Designation",
  TESTIMONIAL_CONTENT: "Testimonial Content",
  TESTIMONIAL_SLIDE: "Testimonial Slide",
  HEADING: "Heading",
} as const;

export interface TestimonialSlide {
  [TESTIMONIAL_SLIDE_FIELDS.BRAND_LOGO]?: {
    url: string;
    name?: string;
    imageMeta?: { width: number; height: number };
  };
  [TESTIMONIAL_SLIDE_FIELDS.AUTHOR_NAME]?: string;
  [TESTIMONIAL_SLIDE_FIELDS.SLIDE_IMAGE]?: {
    url: string;
    name?: string;
    imageMeta?: { width: number; height: number };
  };
  [TESTIMONIAL_SLIDE_FIELDS.AUTHOR_AVATAR]?: {
    url: string;
    name?: string;
  };
  [TESTIMONIAL_SLIDE_FIELDS.SLIDE_ALT_TEXT]?: string;
  [TESTIMONIAL_SLIDE_FIELDS.AUTHOR_AVATAR_ALT]?: string;
  [TESTIMONIAL_SLIDE_FIELDS.AUTHOR_DESIGNATION]?: string;
  [TESTIMONIAL_SLIDE_FIELDS.TESTIMONIAL_CONTENT]?: string;
}
